export const VIEW_PAYMENT_APPROVAL_URL = 'view://Leads/LeadPaymentApproval';
export const VIEW_LEAD_PROFILE_URL = 'view://Leads/Lead_profile';

export const SET_LEAD_PAYMENT_APPROVAL_DATA = 'SET_LEAD_PAYMENT_APPROVAL_DATA';
export const GET_LEAD_PAYMENT_APPROVAL_DATA = 'GET_LEAD_PAYMENT_APPROVAL_DATA';
export const SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA = 'SET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA';
export const GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA = 'GET_LEAD_PAYMENT_APPROVAL_DETAILS_DATA';
export const SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA = 'SAVE_LEAD_PAYMENT_APPROVAL_DETAILS_DATA';

export const GET_LEAD_PAYMENT_APPROVAL_DRIVERS_CATALOG = 'GET_LEAD_PAYMENT_DRIVERS_CATALOG';



// WEBPACK FOOTER //
// ./src/modules/Leads/LeadPaymentApproval/constants/index.js